import type React from 'react';

import { tailwindMerge } from '../../tailwind';
import {
  CheckCircleOutlinedIcon,
  ErrorCircleOutlinedIcon,
  WarningCircleOutlinedIcon,
} from '../Icons';

type Semantic = 'danger' | 'primary' | 'warning';
export interface AlertProps
  extends Omit<React.HTMLProps<HTMLDivElement>, 'as'> {
  semantic?: Semantic;
  children: React.ReactNode;
  testId?: string;
  ref?: React.Ref<HTMLDivElement>;
}

export const Alert = ({
  children,
  testId,
  semantic = 'primary',
  className,
  ...otherProps
}: AlertProps) => (
  <div
    {...otherProps}
    className={tailwindMerge(
      'alert-component',
      'max-w-notification gap-s border-border-light bg-background-white p-m relative flex items-center justify-start rounded border border-solid',
      "before:w-xxs before:rounded-l-regular before:absolute before:top-0 before:bottom-0 before:-left-[1px] before:h-full before:content-['']",
      borderColorClassBySemantic[semantic],
      className,
    )}
  >
    <SemanticIcon semantic={semantic} />
    <div data-testid={testId} className="font-semibold">
      {children}
    </div>
  </div>
);

const borderColorClassBySemantic: Record<Semantic, string> = {
  primary: 'before:bg-components-primary-base',
  warning: 'before:bg-components-warning-base',
  danger: 'before:bg-components-danger-base',
};

const SemanticIcon = ({ semantic }: { semantic: Semantic }) => {
  switch (semantic) {
    case 'primary':
      return (
        <CheckCircleOutlinedIcon className="stroke-components-primary-base" />
      );
    case 'warning':
      return (
        <WarningCircleOutlinedIcon className="stroke-components-warning-base" />
      );
    case 'danger':
      return (
        <ErrorCircleOutlinedIcon className="stroke-components-danger-base" />
      );
  }
};
